import React, { FunctionComponent } from 'react';

import { useTranslation } from 'react-i18next';

import { TRANSLATION_NAMESPACE } from 'directory/listings/notification-modals/constants';
import { PaginationInfoProps } from 'directory/listings/notification-modals/types';
import 'directory/listings/notification-modals/components/PaginationInfo/PaginationInfo.scss';

export const PaginationInfo: FunctionComponent<PaginationInfoProps> = ({ currentPage, pageSize, totalItems }) => {
    const { t } = useTranslation(TRANSLATION_NAMESPACE);

    const startItem = currentPage * pageSize + 1;
    const endItem = Math.min((currentPage + 1) * pageSize, totalItems);

    return (
        <div className="pagination-info">
            <span className="pagination-info__show-items">{t('SHOW_ITEMS', { start: startItem, end: endItem })}</span>{' '}
            {t('OF_LOCATIONS', { total: totalItems })}
        </div>
    );
};
